import { ref, listAll, getDownloadURL } from "firebase/storage";
import { storage } from "lib/firebase";
import { useEffect, useState } from "react";

export function useStore() {
    const [isLoading, setLoading] = useState(true);
    const [paths, setPaths] = useState([]);
    const [imagesUrls, setImagesUrls] = useState([]); // Cambio de imagesUrl a imagesUrls para indicar que es una lista

    const listRef = ref(storage, 'shop/');

    async function getItemsImages() {
        setLoading(true);
        const fileList = await listAll(listRef);
        const pathsToAdd = fileList.prefixes.map(reference => reference._location.path); // Usar map directamente para crear la lista de paths
        setPaths(pathsToAdd);
    }

    useEffect(() => {
        const fetchImagesUrls = async () => {
            const urlsList = await Promise.all(paths.map(async (path) => {
                const itemRef = ref(storage, path);
                const filesIn = await listAll(itemRef);
                const fileUrls = await Promise.all(filesIn.items.map(async (file) => {
                    const fileItemRef = ref(storage, file.fullPath);
                    return getDownloadURL(fileItemRef);
                }));
                return [path, ...fileUrls]; // Crear un arreglo con el path y los URLs de archivos
            }));

            setImagesUrls(urlsList); // Almacenar la lista de URLs en el estado
            setLoading(false); // Marcar que ya no estamos cargando
        };

        if (paths.length > 0) {
            fetchImagesUrls(); // Solo llamar a fetchImagesUrls si hay paths disponibles
        }
    }, [paths]);

    return { isLoading, getItemsImages, paths, imagesUrls };
}

// export function useStore() {
//     const [isLoading, setLoading] = useState(true);
//     const [paths, setPaths] = useState([]);
//     const [imagesUrl, setImagesUrl] = useState([])
//     const listRef = ref(storage, 'shop/');

//     async function getItemsImages() {
//         setLoading(true);
//         const fileList = await listAll(listRef);
//         const pathtoAdd = []
//         fileList.prefixes.forEach(reference => {
//             const path = reference._location.path
//             pathtoAdd.push(path)
//         })
//         setPaths(pathtoAdd)
//     }

//     useEffect(() => {
//         paths.map(async (path) => {
//             console.log('Archivos de: '+path)
//             const itemRef = ref(storage, path)
//             const filesIn = await listAll(itemRef)
//             filesIn.items.map(async (file) => {
//                 const fileItemRef = ref(storage, file.fullPath)
//                 const url = await getDownloadURL(fileItemRef)
//                 console.log(url)
//             })
//         })
//     }, [paths])

//     useEffect(() => {
//         console.log(imagesUrl)
//     }, [imagesUrl])


//     return { isLoading, getItemsImages, paths, imagesUrl }
// }
